import {createContext} from "react";

const MarkerFilterContext = createContext({
  markerFilter: null,
  toggleMarkerFilter: () => {},
  toggleAllMarkerFilter: () => {}
});

export default MarkerFilterContext;



// WEBPACK FOOTER //
// ./src/contexts/markerFilter.js